import { Controller } from 'stimulus';

// Persists the dismissal of portal messages in localStorage so the user does not
// have to close them on every page load. The storage is cleared on the login page
// (login_controller#connect), so dismissed messages show again on the next login/logout.
const STORAGE_KEY = 'portal-messages-dismissed';

export default class extends Controller {
  static values = { key: String };

  connect() {
    // The element is rendered hidden (style="display:none") to avoid flashing a
    // message that was already dismissed. Reveal it only when it is not dismissed.
    if (this.dismissedIds().includes(this.keyValue)) {
      this.element.remove();
    } else {
      this.element.style.display = '';
    }
  }

  dismiss() {
    const ids = this.dismissedIds();
    if (!ids.includes(this.keyValue)) {
      ids.push(this.keyValue);
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
      } catch (e) {
        // Ignore storage errors (private mode / quota).
      }
    }
  }

  dismissedIds() {
    try {
      const ids = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
      return Array.isArray(ids) ? ids : [];
    } catch (e) {
      return [];
    }
  }
}
